import React from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Container,
  Row,
  Col,
} from "reactstrap";


function AccordionSolutions() {
  const [openedCollapse, setOpenedCollapse] = React.useState("collapse-1");
  return (
    <div className="accordion-1">
      <Container>
        <Row>
          <Col className="mx-auto text-center" md="6">
            <h2 className="title font-weight-bold mb-3 mt-5">Terms 	&#38; Conditions</h2>
          </Col>
        </Row>
        <Row>
          <Col className="ml-auto mb-5 bg-default" md="12">
            <div className="accordion" id="T&Cs">
              <Card className="bg-default">
                <CardHeader className="bg-default" id="Terms-1">
                  <h4 className="text-white font-weight-normal">Last modified: March 27, 2023</h4>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-1"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-1" ? "" : "collapse-1"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Read carefully{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-1"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Please carefully read the following Terms and Conditions of Use &#40;&#8220;Agreement&#8221;&#41; 
                      before using our services. CrypTegridy LTD &#40;&#8220;we&#8221;, &#8220;us&#8221;, or 
                      &#8220;our&#8221;&#41; reserves the right, in its sole discretion, to impose, amend, or modify 
                      the terms and conditions of use of this website, or any section of it. Changes, adjustments, 
                      additions, and deletions will take effect immediately after they are posted on the website. You 
                      undertake to examine the terms and conditions regularly and to be aware of any changes. Continued 
                      use of this site will be regarded as conclusive evidence of your acceptance of the updated terms of 
                      use. By using cryptegridy.com, you agree to be governed by the terms and conditions of this 
                      Agreement, as well as the cryptegridy.com Privacy and Security Policy.
                    </p>
                    <p>
                      While using cryptegridy.com, you agree to be bound by this Agreement by utilizing the information, 
                      tools, features, and functionality found on cryptegridy.com, the &#8220;Service&#8221;. All visitors 
                      are referred to as &#8220;you&#8221;, &#8220;User&#8221; or &#8220;users&#8221;. It is your 
                      responsibility to read and understand this Agreement. If you accept this Agreement, you represent 
                      that you have the legal ability to be bound by it, or that you have the right to bind a corporation 
                      or entity if you are acting on behalf of one.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="newsletter">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-2"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-2" ? "" : "collapse-2"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      Newsletter Terms and Conditions:{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-2"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      By signing up for our email subscription, you agree to receive emails from us. We do not share email 
                      addresses with third parties.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="disclaimer">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-3"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-3" ? "" : "collapse-3"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      Disclaimer of Representations and Warranties:{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-3"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      The content, as well as all services and products associated with cryptegridy.com or provided through 
                      the Service &#40;whether sponsored or not&#41;, are provided to you &#8220;as is&#8221; and &#8220;as 
                      available.&#8221; cryptegridy.com makes no express or implied representations or warranties about the 
                      content or operation of cryptegridy.com or the Service. You agree that the use of the Service is at 
                      your sole risk.
                    </p>
                    <p>
                      Cryptegridy.com makes no representation, warranty, or guarantee that the content available through the 
                      Service is free of viruses or other code or computer programming routines with contaminating or 
                      destructive properties or intended to damage, surreptitiously intercept, or expropriate any system, 
                      data, or personal information.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="not-financial-advice">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-4"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-4" ? "" : "collapse-4"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Not a Financial Advisor:{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-4"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Neither cryptegridy.com nor the Service are intended to provide legal, tax, or financial advice. We offer 
                      no financial services of any kind. We are a blockchain security consultancy, and all services offered are 
                      on a consultancy basis. Always conduct your research; we cannot be held liable for any losses. As a result, 
                      you should seek further information and advice from your accountant or other financial advisors who are 
                      fully aware of your individual circumstances before making any final choices or adopting any financial 
                      strategy.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="cookies">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-5"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-5" ? "" : "collapse-5"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Use of Cookies:{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-5"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      We employ the use of cookies. By accessing this website and domain, you agree to the use of cookies in accordance 
                      with the cryptegridy.com Privacy Policy. Most interactive websites use cookies to enable the functionality of 
                      certain areas to make it easier for people visiting our website.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="restrictions">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-6"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-6" ? "" : "collapse-6"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Use Restrictions:{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-6"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      There are certain conducts that are strictly prohibited on the Site and the Service. Please read the following 
                      restrictions carefully. Your failure to comply with any of the provisions set forth herein may result in the 
                      termination of your access to the Site.
                    </p>
                    <p>
                      You may not, whether by yourself or anyone on your behalf:
                    </p>
                    <ul>
                      <li>
                        Use the Site and the Service for any illegal, unlawful, or unauthorized purposes. Any such use will be considered 
                        a breach of these terms and conditions, and CrypTegridy LTD reserves the right to take legal action against you.
                      </li>
                      <li>
                        Use the Site and the Service to engage in any form of spam, unsolicited mail, or similar conduct. Such activities 
                        are strictly prohibited, and CrypTegridy LTD reserves the right to terminate your access to the Site and the Service 
                        if you engage in such conduct.
                      </li>
                      <li>
                        Interfere with or violate users&#39; rights to privacy and other rights or harvest or collect data and information 
                        about users without their express consent, whether manually or with the use of any robot, spider, crawler, or any 
                        search or retrieval application. Any such conduct will be considered a violation of these terms and conditions, and 
                        CrypTegridy LTD reserves the right to take legal action against you.
                      </li>
                      <li>
                        Interfere with or disrupt the operation of the Site, the Service, or the servers or networks that host the Site and 
                        the Service, or disobey any laws, regulations, or requirements, procedures, policies, or regulations of such servers 
                        or networks. Any such conduct is strictly prohibited and may result in the termination of your access to the Site and 
                        the Service.
                      </li>
                      <li>
                        Impersonate any person or entity or provide false information on the Site or through the Service, whether directly or 
                        indirectly. Such conduct is strictly prohibited and may result in the termination of your access to the Site and the 
                        Service.
                      </li>
                      <li>
                        Falsely state or otherwise misrepresent your affiliation with any person or entity, or express or imply that CrypTegridy 
                        LTD or any third party endorses you, your website, your business, or any statement you make, or present false or 
                        inaccurate information about the Site or the Service. Any such conduct is strictly prohibited and may result in the 
                        termination of your access to the Site and the Service.
                      </li>
                      <li>
                        Transmit, distribute, display or otherwise make available through or in connection with the Site or the Service any 
                        content, including user-generated content, which may infringe third-party rights, including intellectual property rights 
                        and privacy rights, or which may contain any unlawful content. Any such conduct is strictly prohibited and may result in 
                        the termination of your access to the Site and the Service.
                      </li>
                      <li>
                        Take any action that imposes, or may impose, in our sole discretion, an unreasonable or disproportionately large load on 
                        our platform infrastructure or that may otherwise adversely affect the User's experience in connection with the Site or 
                        the Service.
                      </li>
                      <li>
                        Bypass any measures we may use to prevent or restrict access to the Site or the Service.
                      </li>
                      <li>
                        Copy, modify, alter, adapt, make available, translate, port, reverse engineer, decompile, or disassemble any portion of 
                        the Site or the Service in any way. Any such conduct is strictly prohibited and may result in the termination of your access 
                        to the Site and the Service.
                      </li>
                      <li>
                        Create a browser, frame, border environment, or GUI around the Site.
                      </li>
                    </ul>
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AccordionSolutions;
